import { Input } from '@presentation/components/molecules'
import { TextInputProps } from '@presentation/types/components/molecules'

const TextInput: React.FC<TextInputProps> = ({ rows = 5, ...rest }) => {
  return <Input as="textarea" {...rest} rows={rows} />
}

export default TextInput
